import { formatDate } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { DetalleSolicitud } from '../../core/model/detalle-solicitud';
import { AuthenticationService } from '../../core/services/authentication.service';
import { UtilitiesService } from '../../core/services/Utility/utilities.service';

@Component({
  selector: 'app-export-table',
  templateUrl: './export-table.component.html',
  styleUrls: ['./export-table.component.css']
})
export class ExportTableComponent implements OnInit {

  @Input() rows: any[];
  @Input() columns: any[];
  @Input() rowsSelected: any[] = [];

  @Input() getDataFunction: any;
  @Input() filename: string;

  @Input() set datasToExport(datas: any[]) {
    if (datas) {
      this.downloadCSVData(datas);
     }
  }

  //🥑🥑 SRR paso todos los valores de la solicitud para mostrarlo en el excel
  @Input() viewDetails: DetalleSolicitud;
  @Input() idSolicitud: number;
  isdocout = false;

  @Output() searchDatas = new EventEmitter<boolean>();



  constructor(private translateService: TranslateService,
    private toastr: ToastrService,
    private authService: AuthenticationService,
    private utilservice: UtilitiesService) { }

  ngOnInit() {
    this.authService.isDocOutUser().then((r: boolean) => this.isdocout = r).catch((r: Error) => this.isdocout = false);
  }

  exportAllDatas() {
    this.toastr.info(this.translateService.instant('mensajes.downloadfileinprogress'));

    this.searchDatas.emit(true);
  }


  downloadCSVData(values) {
    const csv = this.generateCSVFromValues(values);

    const fileName = this.filename + '.csv';

    this.utilservice.downloadDataInCSV(fileName, csv);
  }

  private generateCSVFromValues(values: any): string {
    let csvString = 'CLIENTE;SOLICITUD;CONTENIDO;SERIE;TIPO SERVICIO;SOLICITANTE;ALTA SOLICITUD;FIN SOLICITUD;LIMITE SOLICITUD;ESTADO SOLICITUD;SITUACION SOLICITUD;' + this.convertValuesToCSVRow(this.columns.map(column => column.name));


    if (this.isdocout) {

        values.forEach(value => {
          const data = this.columns.map(column => this.getData(column, value));
          csvString += this.viewDetails.NOMBRE_CLIENTE + ';' +
            this.idSolicitud + ';' +
            value.contenidoId + ';' +
            this.viewDetails.NOMBRE_SERIE + ';' +
            this.viewDetails.NOMBRE_TIPO_SERVICIO + ';' +
            this.viewDetails.NOMBRE_USUARIO_SOLICITANTE + ';' +
            (this.viewDetails.FECHA_CREACION != null ? formatDate(this.viewDetails.FECHA_CREACION, 'dd/MM/yyyy', 'en-US') : '') + ';' +
            (this.viewDetails.FECHA_FINALIZACION != null ? formatDate(this.viewDetails.FECHA_FINALIZACION, 'dd/MM/yyyy', 'en-US') : '') + ';' +
            (this.viewDetails.FECHA_SLA != null ? formatDate(this.viewDetails.FECHA_SLA, 'dd/MM/yyyy', 'en-US') : '') + ';' +
            this.viewDetails.NOMBRE_ESTADO_DOCOUT + ';' +
            this.viewDetails.NOMBRE_SITUACION_DOCOUT + ';' +
                          this.convertValuesToCSVRow(data);
                          });
    }
    else
    {
        values.forEach(value => {
          const data = this.columns.map(column => this.getData(column, value));
          csvString += this.viewDetails.NOMBRE_CLIENTE + ';' +
            this.idSolicitud + ';' +
            value.contenidoId + ';' +
            this.viewDetails.NOMBRE_SERIE + ';' +
            this.viewDetails.NOMBRE_TIPO_SERVICIO + ';' +
            this.viewDetails.NOMBRE_USUARIO_SOLICITANTE + ';' +
            (this.viewDetails.FECHA_CREACION != null ? formatDate(this.viewDetails.FECHA_CREACION, 'dd/MM/yyyy', 'en-US') : '') + ';' +
            (this.viewDetails.FECHA_FINALIZACION != null ? formatDate(this.viewDetails.FECHA_FINALIZACION, 'dd/MM/yyyy', 'en-US') : '') + ';' +
            (this.viewDetails.FECHA_SLA != null ? formatDate(this.viewDetails.FECHA_SLA, 'dd/MM/yyyy', 'en-US') : '') + ';' +
            this.viewDetails.NOMBRE_ESTADO_DOCOUT + ';' +
            this.viewDetails.NOMBRE_SITUACION_DOCOUT + ';' +
            this.convertValuesToCSVRow(data);
            });
      }

    return csvString;
  }

  private convertValuesToCSVRow(values: any[]): string {
    // Quitamos los intros que pueda haber en los datos
    const reg = new RegExp('^[0-9]+$');
    return values.map(value => {
      let data = typeof value === 'string' ? value.replace(/(\r\n|\n|\r)/gm, '') : value;
      if (reg.test(data) && data.toString().length > 11) {
        data = data + '\t';
      }
      return data;
    }  ).join(';') + '\n';
  }

  private getData(column: any, data: any): string {
    if (this.getDataFunction) {
      return this.getDataFunction(column, data);
     }
    return data[column.prop];
  }

}
